import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Modal

} from "reactstrap";

import { Field, reduxForm } from "redux-form";
import API from "../../../Common/api";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'


var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var From_Date_val = "";
var to_Date_val = "";


const exportToCSVData = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  var Heading = []
  if (fileName == "Pick Task Detailed Report") {
    Heading = [['Facility Code', 'Brand','Group Id', 'Sub group ID','Sheet Type', 'Jarvis Product Id', 'SKU7 code', 'Product Name', 'PKD', 'MRP', 'UPC', 'Total Allocation Qty', 'CLD Allocation Qty', 'Loose Allocation Qty', 'Pick task Assignment Time', 'Total Picked Qty', 'CLD Picked Qty', 'Loose Picked Qty', 'Reason for shortage','Pick Type', 'Bin ID','Bin Type', 'CLD Container ID', 'Loose Container ID', 'Bin Scan Time', 'CLD Container Scan Time', 'Loose Container Scan Time', 'Picking Complete Time', 'Picker Name']];
  }
  if (fileName == "Pick Task Consolidated Report") {
    Heading = [['warehouse', 'Group ID', 'Sub group ID','Sheet Type', 'SKU Count', 'Order line count', 'Total Qty', 'Total CLD Qty', 'Total Loose Qty', 'Pick task Assignment Time', 'Picking Type', 'Picking start time', 'Picking Completion time', 'Users Assigned', 'Total Picked qty', 'Picked CLD Qty', 'Picked Loose Qty', 'Total Short / Pending Qty']]
  }

  exportToCSV(csvData, fileName, Heading)

  
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

    this.state = {
      orderdata: [],
      ShowpopupLoader: false,
      showFromErr: false,
      showToErr: false,
      showFilter: false,
      ShowConfirmLoader: false,
      btnDisabled: true,
      isDisabledSearch: false,
      filtered_orderData: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      view_type: "",
      fromdate: "",
      todate: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      sku: "",
      order: "",
      subgroup :"",
      tableRowsMap: [],
      tableRowsMap1: [],
      detailed_view: true,
      consolidated_view: "",
      showFetchDispatchData: false,
      showFetchDispatchData1: false,
      filter_model : false,
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""
    };
  }

  handleChange = (evt) => {
    if (evt.target.value == "detailed_view") {
      this.setState({ detailed_view: true, consolidated_view: false, tableRowsMap: [], tableRowsMap1: [], showFetchDispatchData1: false })
    }
    else if (evt.target.value == "consolidated_view") {
      this.setState({ detailed_view: false, consolidated_view: true, tableRowsMap: [], tableRowsMap1: [], showFetchDispatchData: false })
    }

  }

  onOrderChange = (evt) => {
    this.setState({
      order: evt.target.value,
    });
  };

  onSKUChange = (evt) => {
    this.setState({
      sku: evt.target.value,
    });
  };

  onSubGroupChange = (evt) => {
    this.setState({
      subgroup: evt.target.value.trim(),
    });
  };

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    // var today = new Date();
    // From_Date_val = this.convertDate(today);
    // to_Date_val = this.convertDate(today);

    //From_Date_val = today;
    //to_Date_val = today;

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccessConfirmoktoggle() {
    this.setState({
      SuccessConfirmmodal: false,
    });

    window.location.reload();
    /*window.location.href="/putaway/printPutaway";*/
  }
  toggleOK = () =>  {
    this.setState({
      filter_model : false,
    });}

  fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });
    if (!(this.state.subgroup) && !(this.state.order) && !(this.state.sku) && !(From_Date_val) && !(to_Date_val)) {
      this.setState({
        filter_model :true,
        loading: false,
      })
    }
    else{
        var view_type = ""
        if (this.state.detailed_view == true) {
          view_type = "detailed_view"
          this.setState({
            view_type: "detailed_view"
          })
        }
        else if (this.state.consolidated_view == true) {
          view_type = "consolidated_view"
          this.setState({
            view_type: "consolidated_view"
          })
        }
        const payload = {
          request_type: "view",
          sub_group: this.state.subgroup,
          to_date: to_Date_val,
          from_date: From_Date_val,
          order: this.state.order,
          sku: this.state.sku,
          "view_type": view_type,
        };
        addAnalytics('Report', 'View Pick Task Report', payload);

        API.post("/reports/pick-task-report/", { param: payload })
          .then((response) => response.data)
          .then((data) => {

            if (data.length == 0) {

              this.setState({
                dispatch_status: true,
                // showFetchDispatchData: true,
                loading_overlay: false,
                loading: false,
              });
              return false;
            }
            if (data.data_type == "detailed_view") {
              this.setState({
                tableRowsMap: this.assembleDispatchData(data.data),
                showFetchDispatchData: true,
                dispatch_status: false,
                loading: false,
              });

            }
            if (data.data_type == "consolidated_view") {
              this.setState({
                tableRowsMap1: this.assembleDispatchData1(data.data),
                showFetchDispatchData1: true,
                dispatch_status: false,
                loading: false,
              });
            }

          })
          .catch(function (error) { });
      };}
  
  assembleDispatchData = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else { status = " Not Active" }
      return {

        warehouse_code: post.warehouse_code,
        brand : post.brand,
        group_id: post.group_id,
        sub_group_id: post.subgroup_id,
        sheet_type : post.sheet_type,
        jarvis_product_id: post.jarvis_product_id,
        sku7_code: post.product_code,
        product_name: post.product_name,
        pkd: post.pkd,
        mrp: post.mrp,
        upc: post.upc,
        total_allocation_qty: post.total_alloc_qty,
        cld_allocation_qty: post.cld_alloc_qty,
        loose_allocation_qty: post.loose_alloc_qty,
        pick_task_assignment_time: post.pick_assign_time,
        total_picked_qty: post.total_picked_qty,
        cld_picked_qty: post.cld_pick_qty,
        loose_picked_qty: post.loose_picked_qty,
        reason_for_shortage: post.reason,
        pick_type : post.pick_type,
        bin_id: post.bin_id,
        bin_type: post.bin_type,
        cld_container_id: post.cld_container_id,
        loose_container_id: post.loose_container_id,
        bin_scan_time: post.bin_scan_time,
        cld_container_scan_time: post.cld_container_scan_time,
        loose_container_scan_time: post.loose_container_scan_time,
        picking_complete_time: post.picking_complete_time,
        picker_id: post.picker_name


      };
    });


    this.setState({
      loading_overlay: false,
      filtered_orderData: posts,
      orderData: posts,
      // posts : posts,
    });

    return posts;
  };
  assembleDispatchData1 = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else { status = " Not Active" }
      return {

        warehouse_code: post.warehouse_code,
        group_id: post.group_id,
        sub_group_id: post.subgroup_id,
        sheet_type : post.sheet_type,
        sku_count: post.sku_count,
        order_line_count: post.order_line_count,
        total_qty: post.total_qty,
        total_cld_qty: post.total_cld_qty,
        total_loose_qty: post.total_loose_qty,
        picking_assign_time: post.picking_assign_time,
        picking_type: post.picking_type,
        picking_start_time: post.picking_start_time,
        picking_complete_time: post.picking_complete_time,
        user_assigned: post.user_assigned,
        total_picked_qty: post.total_picked_qty,
        picked_cld_qty: post.picked_cld_qty,
        picked_loose_qty: post.picked_loose_qty,
        total_short: (post.total_qty - post.total_picked_qty),

      };
    });


    this.setState({
      loading_overlay: false,
      filtered_orderData: posts,
      orderData: posts,
      // posts : posts,
    });

    return posts;
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      request_type: "download",
      to_date: to_Date_val,
      from_date: From_Date_val,
      order: this.state.order,
      sku: this.state.sku,
      sub_group: this.state.subgroup
    };



    API.post("/reports/pick-task-report/", { param: payload })

      .then((response) => response.data)
      .then((data) => {
        this.setState({
          //showFetchDispatchData: true,
          loading: false,
        });

        window.location.href = data.data;
      })
      .catch(function (error) { });
  };

  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
        {
          label: "warehouse ",
          field: "warehouse_code",
          width: 150,
        },
        {
          label: "Brand",
          field: "brand",
          width: 120,
        },
        {
          label: "Group ID",
          field: "group_id",
          width: 120,
        },
        {
          label: "Sub group ID",
          field: "sub_group_id",
          width: 120,
        },
        {
          label: "Sheet Type",
          field: "sheet_type",
          width: 120,
        },
        {
          label: "Jarvis Product Id",

          field: "jarvis_product_id",
          width: 130,
        },
        {
          label: "SKU7 code",

          field: "sku7_code",
          width: 120,
        },
        {
          label: "Product Name",

          field: "product_name",
          width: 120,
        },
        {
          label: "PKD",

          field: "pkd",
          width: 130,
        },

        {
          label: "MRP",

          field: "mrp",
          width: 130,
        },
        {
          label: "UPC",

          field: "upc",
          width: 130,
        },

        {
          label: "Total Allocation Qty",

          field: "total_allocation_qty",
          width: 150,
        },

        {
          label: "CLD Allocation Qty",

          field: "cld_allocation_qty",
          width: 160,
        },
        {
          label: "Loose Allocation Qty",

          field: "loose_allocation_qty",
          width: 160,
        },
        {
          label: "Pick task Assignment Time",

          field: "pick_task_assignment_time",
          width: 160,
        },
        {
          label: "Total Picked Qty",

          field: "total_picked_qty",
          width: 160,
        },
        {
          label: "CLD Picked Qty",

          field: "cld_picked_qty",
          width: 160,
        },
        {
          label: "Loose Picked Qty",

          field: "loose_picked_qty",
          width: 160,
        },
        {
          label: "Reason for shortage",

          field: "reason_for_shortage",
          width: 160,
        },
        {
          label: "Pick Type",

          field: "pick_type",
          width: 100,
        },
        {
          label: "Bin ID",

          field: "bin_id",
          width: 180,
        },
        {
          label: "Bin Type",

          field: "bin_type",
          width: 160,
        },
        {
          label: "CLD Container ID",

          field: "cld_container_id",
          width: 160,
        },
        {
          label: "Loose Container ID",

          field: "loose_container_id",
          width: 160,
        },
        {
          label: "Bin Scan Time",

          field: "bin_scan_time",
          width: 160,
        },
        {
          label: "CLD Container Scan Time",

          field: "cld_container_scan_time",
          width: 160,
        },
        {
          label: "Loose Container Scan Time",

          field: "loose_container_scan_time",
          width: 160,
        },
        {
          label: "Picking Complete Time",
          field: "picking_complete_time",
          width: 150,
        },
        {
          label: "Picker Name",

          field: "picker_id",
          width: 160,
        },
      ],

      rows: this.state.tableRowsMap,
    };
    const dispatchData1 = {
      columns: [
        {
          label: "warehouse ",

          field: "warehouse_code",
          width: 150,
        },
        {
          label: "Group ID",

          field: "group_id",
          width: 120,
        },
        {
          label: "Sub group ID",

          field: "sub_group_id",
          width: 120,
        },
        {
          label: "Sheet Type",
          field: "sheet_type",
          width: 120,
        },

        {
          label: "SKU Count",

          field: "sku_count",
          width: 100,
        },

        {
          label: "Order line count",

          field: "order_line_count",
          width: 120,
        },

        {
          label: "Total Qty",

          field: "total_qty",
          width: 130,
        },
        {
          label: "Total CLD Qty",

          field: "total_cld_qty",
          width: 120,
        },
        {
          label: "Total Loose Qty",
          field: "total_loose_qty",
          width: 120,
        },
        {
          label: "Pick task Assignment Time",

          field: "picking_assign_time",
          width: 130,
        },

        {
          label: "Picking Type",

          field: "picking_type",
          width: 130,
        },
        {
          label: "Picking start time",

          field: "picking_start_time",
          width: 130,
        },

        {
          label: "Picking Completion time",

          field: "picking_complete_time",
          width: 150,
        },

        {
          label: "Users Assigned",

          field: "user_assigned",
          width: 160,
        },
        {
          label: "Total Picked qty",

          field: "total_picked_qty",
          width: 160,
        },
        {
          label: "Picked CLD Qty",

          field: "picked_cld_qty",
          width: 160,
        },
        {
          label: "Picked Loose Qty",

          field: "picked_loose_qty",
          width: 160,
        },
        {
          label: "Total Short / Pending Qty",

          field: "total_short",
          width: 160,
        },
      ],

      rows: this.state.tableRowsMap1,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <Overlay>
            <form className="form">
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
              {(this.state.detailed_view || this.state.consolidated_view) &&
                <div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">From Date</span>
                    <div style={{ position: 'relative' }}>
                      
                      <DatePicker
                        selected={this.state.from_date}
                        onChange={this.FromDateChange}
                        className="ledger_fromdate"
                        placeholderText="From Date"
                        format='yyyy-MM-dd'

                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>

                      {this.state.showFromErr && (
                        <span style={{ color: "red", fontSize: 11 }}>
                          Please Select From Date
                        </span>
                      )}
                      {this.state.dateOrderError && (
                        <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                      )}
                    </div>
                  </div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">From Date</span>
                    <div style={{ position: 'relative' }}>
                      <DatePicker
                        selected={this.state.to_date}
                        onChange={this.ToDateChange}
                        className="ledger_todate"
                        placeholderText="To Date"
                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                      {this.state.showToErr && (
                        <span style={{ color: "red", fontSize: 11 }}>
                          Please Select To Date
                        </span>
                      )}

                      {this.state.showToErr &&
                        <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                      }
                      {this.state.dateRangeError &&
                        <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                      }
                    </div>
                  </div>
                </div>
              }
              {this.state.detailed_view &&
                <div>
                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">Order No.</span>
                    <div style={{ position: 'relative' }}>
                      <input
                        type="text"
                        style={{ height: 38 }}
                        className="form-control"
                        placeholder="Enter Order No."
                        onChange={this.onOrderChange}
                      />
                    </div>
                  </div>


                  <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                    <span className="date_title">SKU7</span>
                    <div style={{ position: 'relative' }}>
                      <input
                        type="text"
                        style={{ height: 38 }}
                        className="form-control"
                        placeholder="Enter SKU7"
                        onChange={this.onSKUChange}
                      />
                    </div>
                  </div>
                </div>
              }

              {(this.state.detailed_view || this.state.consolidated_view) &&

                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">Sub Group</span>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      style={{ height: 38 }}
                      className="form-control"
                      placeholder="Enter Sub Group"
                      onChange={this.onSubGroupChange}
                    />
                 </div>
                </div>
              }

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">View Type</span>
                <div style={{ position: 'relative' }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13,}}
                    onChange={this.handleChange}
                  // name="year"               
                  >
                    <option value="detailed_view">Select View Type</option>
                    <option value="detailed_view">Detailed View </option>
                    <option value="consolidated_view">Consolidated View </option>
                  </select>
                </div>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
               
                {(this.state.detailed_view &&
                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                     onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Pick Task Detailed Report")}>
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                  Download
                </Button>
                )}

                {(this.state.consolidated_view &&

                  <Button
                      type="button"
                      className="btn btn-primary-outline"
                      style={{
                          cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                          backgroundColor: '#FFFFFF',
                          color: '#333333', // Set text color
                          display: 'flex',   // Use flexbox to align image and text
                          alignItems: 'center' // Center items vertically
                      }}
                      id="button_download"
                        onClick={(e) => exportToCSVData(this.state.filtered_orderData, "Pick Task Consolidated Report")}>
                      <img
                          src={DownloadIcon}
                          alt="Download"
                          style={{ width: '22px' }} // Adjust size as needed
                      />
                      Download
                    </Button>
                  )}

              </ButtonToolbar>
            </div>
              
          </form>
        </Overlay>

          {!this.state.showFetchDispatchData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

          {this.state.showFetchDispatchData && (

            <div>
              <div>

                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                }

                {this.state.order &&
                  <div className="date-container">
                   {this.state.order}
                  </div>
                }

                {this.state.sku &&
                  <div className="date-container">
                   {this.state.sku}
                  </div>
                }

                {this.state.sub_group &&
                  <div className="date-container">
                   {this.state.sub_group}
                  </div>
                }

                {this.state.view_type &&
                  <div className="date-container">
                   {this.state.view_type}
                  </div>
                }




              </div>
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    scrollX
                    scrollY
                    sortable={false}
                    maxHeight="390px"
                    displayEntries={false}
                    striped
                    bordered
                    onSearch={this.filterData}
                    data={dispatchData}
                  />
                </div>
              </div>
            </div>
          )}
          {this.state.showFetchDispatchData1 && (

            <div>
              <div>

                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                }
                {this.state.sub_group &&
                  <div className="date-container">
                   {this.state.sub_group}
                  </div>
                }

                {this.state.view_type &&
                  <div className="date-container">
                   {this.state.view_type}
                  </div>
                }
              </div>
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    scrollX
                    scrollY
                    sortable={false}
                    maxHeight="390px"
                    displayEntries={false}
                    striped
                    bordered
                    onSearch={this.filterData}
                    data={dispatchData1}
                  />
                </div>
              </div>
            </div>
          )}

        </Card>
        <Modal isOpen={this.state.filter_model} >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              // onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "red" }}
            />
            <h4> One of the Filter is Mandatory</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));